<template>
  <div>
    <div v-if="reportStatus==='absent'">
      <button class="button is-info" v-on:click="generateReport">
        <span>{{$t('campaigns.reportTexts.createReport')}}</span>
      </button>

    </div>
    <div v-else-if="reportStatus==='generating'" class = "waiting button is-primary">
      <Loader color="white"/><span>{{$t('campaigns.reportTexts.reportIsBeingGeneratedNow')}}</span>
    </div>
    <div v-else-if="reportStatus==='exist' && reportLink">
      <a class="button is-success" v-bind:href="reportLink">
          <span class="icon">
            <i class="fa fa-download"></i>
          </span>
        <span>{{$t('common.actions.load')}}</span>
      </a>
      <button class="button is-info" v-on:click="generateReport">
        <span>{{$t('common.actions.reCreate')}}</span>
      </button>
    </div>
    <div v-else-if="reportStatus==='fail'">
      <span>{{$t('campaigns.reportTexts.createReportError')}}</span>
    </div>
  </div>
</template>

<script>
    import Loader from '../components/loaders/Loader1'
    const REPORTS_GENERATE_API = '/report'

    export default {
        name: 'ReportGenerator',
        components: {Loader},
        props: ['campaignId', 'status', 'checkStatusWhenCreated'],
        data: function () {
          return {
            reportStatus: '',
            reportLink: '',
            checkStatusTimer: null
          }
        },
        created() {
          if (this._props.campaignId && this._props.checkStatusWhenCreated) {
            this.checkStatus()
          }
        },
        methods: {
          checkStatus() {
            console.log('checkStatus')
            let that = this
            this.$http({
              url: REPORTS_GENERATE_API + '/checkStatus/' + this._props.campaignId
            }).then((response) => {
              that.reportStatus = response.data
            }).catch((error) => {
              console.log(error)
            })
          },
          generateReport() {
            let that = this
            that.reportStatus = 'generating'

            that.$http({
              url: REPORTS_GENERATE_API + '/generateAsync/' + that._props.campaignId
            }).then(() => {
              // that.reportStatus = 'exist'
            }).catch((error) => {
              that.reportStatus = 'fail'
              console.log(error)
            })
          },
          initCheckStatusInterval() {
            this.checkStatusTimer = setInterval(this.checkStatus, 4000)
          },
          clearCheckStatusInterval() {
            if (this.checkStatusTimer) {
              clearInterval(this.checkStatusTimer)
              this.checkStatusTimer = null
            }
          }
        },
      watch: {
        reportStatus: function (val) {
          console.log('reportStatus ' + val)
          this.clearCheckStatusInterval()
          if (val === 'generating') {
            this.initCheckStatusInterval()
          } else if (val === 'exist') {
            this.reportLink = REPORTS_GENERATE_API + '/generatedReports/' + this._props.campaignId
          }
        },
        campaignId: function() {
          this.checkStatus()
        },
        status: function(val) {
          this.reportStatus = val
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ReportGenerator.vue?c5829ce0